<template>
  <div class="customcard">
    <h3>Edit user</h3>
    <div v-if="initial_data_fetched" class="d-flex justify-content-center">
      <div class="col-8">
        <form @submit.prevent>
          <div class="form-group">
            <label for="name">Enter Name</label>
            <input type="text" class="form-control" id="name" aria-describedby="nameHelp" placeholder="Enter name"
                   v-model="name" @keyup="nameKeyUp">
            <span id="nameHelp" class="form-text text-danger">
                        {{ name_warning }}
                    </span>
          </div>
          <div class="form-group">
            <label for="phone">Phone Number</label>
            <input type="text" class="form-control" id="phone" aria-describedby="phoneHelp"
                   placeholder="Enter phone number"
                   v-model="phone" @keyup="phoneKeyUp">
            <span id="phoneHelp" class="form-text text-danger">
                       {{ phone_warning }}
                    </span>
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="text" class="form-control" v-model="email">
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" class="form-control" id="password" placeholder="Password"
                   v-model="password" @keyup="passwordKeyUp">
            <span id="phoneHelp" class="form-text text-danger">
                        {{ password_warning }}
                    </span>
          </div>
          <div class="form-group">
            <label for="password_confirmation">Confirm Password</label>
            <input type="password" class="form-control" id="password_confirmation" placeholder="Confirm Password"
                   v-model="password_confirmation" @keyup="passwordConfirmKeyUp">
            <span id="phoneHelp" class="form-text text-danger">
                        {{ password_confirmation_warning }}
                    </span>
          </div>

          <CRow>
            <CCol sm="12">
              <img :src="img_url" style="width: 200px; height: 200px"/>
              <CInputFile
                  label="Image thumbnail"
                  vertical
                  ref="file"
                  type="file"
                  id="file"
                  @change="onImageChange"
              />
              <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
              <label class="text-danger"
              >(Image Size should be (360 X 360) and less than 1 MB)</label
              >
            </CCol>
          </CRow>

          <div class="mx-1 my-2">
            <h3 class="text-danger"> {{ role_warning }} </h3>
            <CheckRoles :savedCheckedRoles="checked_roles" @role-checked="checkedRolesFun"/>
            <span class="text-danger"> {{ checked_roles_warning }} </span>
          </div>
          <button type="submit" class="btn btn-primary" :disabled="disableSubmitBtn"
                  @click="handleSubmit">Submit
          </button>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import CheckRoles from './CheckRoles';
import _ from 'lodash';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: 'EditUser',
  components: {
    CheckRoles,
  },
  data() {
    return {
      name: '',
      name_warning: '',
      phone: '',
      phone_warning: '',
      email: '',
      role_warning: '',
      password: '',
      password_warning: '',
      password_confirmation: '',
      password_confirmation_warning: '',
      checked_roles: [],
      checked_roles_warning: '',
      created_user: null,
      initial_data_fetched: false,
      img_url: "",
      avatar: ""


    }
  },
  created() {
    this.fetchUserById();
  },
  watch:{
    password:function (){
      this.passwordKeyUp();
      this.passwordConfirmKeyUp();
    }
  },
  computed: {
    isPasswordChanged: function (){
      return this.password===this.password_confirmation&&this.password_warning.length===0&&this.password_confirmation_warning.length===0;
    },
    disableSubmitBtn: function () {
      const data = this.$data;
      // console.log('DATA === ', data);
      let rule = this.name.length === 0 || this.phone.length === 0 ||
          this.name_warning.length > 0 || this.phone_warning.length > 0
          // || this.password.length === 0 || this.password_confirmation.length === 0
      || this.password_warning.length > 0 || this.password_confirmation_warning.length > 0
      // || this.checked_roles.length === 0
      ;
      return rule;
    }
  },
  methods: {
    handleSubmit() {
      console.log("GG");
      this.nameKeyUp();
      /* this.phoneKeyUp();*/
      if (this.disableSubmitBtn === true /*|| this.checked_roles.length === 0*/) {
        // if (this.checked_roles.length === 0) {
        //   this.checked_roles_warning = "You haven't select any roles";
        // }
        return;
      }
      console.log('Yes , you are prepeared to do action. . . . ');
      const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("image", this.avatar);
      formData.append("roles_ids", JSON.stringify(this.checked_roles));
      formData.append("_method", "patch");
      if (this.isPasswordChanged) {
        formData.append("password", this.password);
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };
      const user_id = this.$route.params.id;
      const URL = `${ADMIN_URL}/users/${user_id}`;
      axios.post(URL, formData, config)
          .then(response => {
            this.$swal("Success", response.data.message, "success");
            // this.handleResponse(response);
          }).catch(error => {
        this.$swal("Error", error.message, "error");
      });
    },
    handleResponse(response) {
      if (response.status === 200) {
        const data = response.data;
        if (Object.prototype.hasOwnProperty.call(data, 'phone')) {
          this.phone_warning = data.phone[0];
        }
        if (Object.prototype.hasOwnProperty.call(data, 'role_warning')) {
          this.role_warning = data.role_warning;
        }
      } else if (response.status === 204) {
        alert('User updated successfully');
        this.$router.push({name: 'Users'});
      }
    },
    checkedRolesFun(parm) {
      this.checked_roles = parm;
      this.checked_roles_warning = '';
    },
    nameKeyUp() {
      if (this.name.length === 0) {
        this.name_warning = 'Enter name';
      } else if (this.name.trim().length === 0) {
        this.name_warning = 'Name cant be empty';
      } else if (this.name.length > 100) {
        this.name_warning = 'Name must be less than 100 letters';
      } else {
        this.name_warning = '';
      }
    },
    phoneKeyUp() {
      const phoneIsValid = this.$gbvar.is_valid_phone(this.phone);
      if (phoneIsValid === false) {
        this.phone_warning = 'Invalid phone number';
      } else {
        this.phone_warning = '';
      }

      if (this.phone.length < 11 || this.phone.length > 11) {
        this.phone_warning = 'Enter a valid phone number';
      }
      if (this.phone.length === 0) {
        this.phone_warning = '';
      }
    },
    passwordKeyUp() {
      if (this.password.length < 6 && this.password.length > 0) {
        this.password_warning = 'Password must be at least 6 char long';
      } else {
        this.password_warning = '';
      }
    },
    passwordConfirmKeyUp() {
      if (this.password !== this.password_confirmation) {
        this.password_confirmation_warning = 'Password not matched';
      } else if(this.password.length !==0 && this.password_confirmation==0)
      {
        this.password_confirmation_warning = 'Please confirm Password';
      }
      else {
        this.password_confirmation_warning = '';
      }
    },
    fetchUserById() {
      const user_id = this.$route.params.id;
      axios.get(`${ADMIN_URL}/users/${user_id}`)
          .then(res => {
            const respData = {...res.data};
            this.checked_roles = respData.roles;
            _.map(this.checked_roles, role => {
              delete role['pivot']; // Because, All roles fetched in CheckRoles.vue have no "pivot" key.
            })
            this.name = res.data.name;
            this.phone = res.data.phone;
            this.email = res.data.email;
            this.img_url = ROOT_URL + "/" + res.data.avatar;
            this.avatar = res.data.avatar;
            this.initial_data_fetched = true;

          }).catch(err => {
        console.log('Error ...___...', err.response);
      })
    },
    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.avatar = file;
      this.img_url = URL.createObjectURL(file);
    },

  }
}
</script>

<style>

</style>
